import React from 'react'
import PropTypes from 'prop-types'
import { Container, Columns, Column } from '@resurs/midas-react'
import { colors } from '@resurs/midas'

const borderTop = type => {
  switch (type) {
    case 'danger':
      return `3px solid ${colors.red}`
    case 'warning':
      return `3px solid ${colors.orange}`
    case 'success':
      return `3px solid ${colors.green}`
    case 'info':
      return `3px solid ${colors.blue}`
    default:
      return '1px solid rgba(0,0,0,0.12)'
  }
}

const Page = ({ title, type, transparent, children, dataCy, noPadding }) => {
  const style = transparent
    ? {
        background: 'transparent',
      }
    : {
        border: '1px solid rgba(0,0,0,0.12)',
        borderTop: borderTop(type),
        background: 'white',
      }
  return (
    <Container>
      <Columns>
        <Column col12 noPadding={!!noPadding}>
          <div {...((dataCy && { 'data-cy': dataCy }) || {})}>
            {title && (
              <h6
                style={{
                  textShadow: '1px 1px 1px #fff',
                  padding: '0.5rem 0 0 0',
                }}
              >
                <strong>{title}</strong>
              </h6>
            )}
            {children && (
              <div style={style}>
                <Column col12 noPadding>
                  {children}
                </Column>
              </div>
            )}
          </div>
        </Column>
      </Columns>
    </Container>
  )
}

Page.propTypes = {
  title: PropTypes.string,
  type: PropTypes.oneOf(['danger', 'warning', 'success', 'info', 'normal']),
  transparent: PropTypes.bool,
  children: PropTypes.node,
  noPadding: PropTypes.bool,
}

Page.defaultProps = {
  title: null,
  type: 'normal',
  transparent: false,
  children: null,
  noPadding: false,
}

export default Page
